const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the slack channel list component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('slackChannelList', ['Application', 'SlackMessage', '$translate', function(Application, SlackMessage, $translate) {
  return {
    restrict: 'E',
    scope: {
      list: '=',
      update: '&?'
    },
    template: require('../../../templates/directives/cms/slack-channel-list.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.directory = {};
      self.channels = [];
      self.activeChannels = [];
      self.checkAccessId = '';
      self.init = false;
      self.compare = function(model, val){
        if (!val || !val.name) {
          return false;
        }

        if ($scope.list.indexOf(val.id) !== -1) {
          return false;
        }

        if (!model) {
          return true;
        }

        var regex = new RegExp("^" + model.toLowerCase(), "g");
        return regex.test(val.name.toLowerCase());
      };

      self.search = '';

      self.setActiveChannels = function() {
        self.activeChannels = self.channels.filter(function(item) {
          return self.compare(self.search, item);
        });
      };

      $scope.$watch('slackChannels.search', function(newVal, oldVal) {
        if (!self.channels || !self.channels.length) {
          return;
        }

        self.setActiveChannels();
      });

      self.addChannel = function(channel){
        $scope.list.push(channel.id);

        if ($scope.update) {
          $scope.update();
        }

        self.search = '';
        self.setActiveChannels();
        setTimeout(function() {
          self.focused = false;
          $scope.$apply();
        }, 1);
      };

      self.removeChannel = function(channel){
        $scope.list.forEach(function(item, idx) {
          if (item === channel) {
            $scope.list.splice(idx, 1);
          }
        });

        if ($scope.update) {
          $scope.update();
        }

        self.setActiveChannels();
      };

      self.checkAccess = function() {
        self.accessLoading = true;
        SlackMessage.checkAccess({subsubresource: self.checkAccessId}).$promise
        .then(function(channel) {
          var addToChannels = true;
          var addToList = true;
          self.checkAccessId = '';
          if (channel && channel.name) {
            self.channels.forEach(function(item) {
              if (item === channel.id) {
                addToChannels = false;
              }
            });
            if (addToChannels) {
              channel.text = channel.name;
              channel.type = channel.id;
              self.directory[channel.id] = channel.name;
              self.channels.push(channel);
            }

            $scope.list.forEach(function(item) {
              if (item === channel.id) {
                addToList = false;
                Application.messaging.addMessage({type: 'info', text: self.translations['slackChannels.previously_added'], duration: 6});
              }
            });

            if (addToList) {
              self.addChannel(channel);
              Application.messaging.addMessage({type: 'info', text: self.translations['slackChannels.channel_added'], duration: 6});
            }
            self.showSelector = false;
            self.accessLoading = false;
            return;
          }

          Application.messaging.addMessage({type: 'error', text: self.translations['slackChannels.channel_unavailable'], duration: 6});
          self.showSelector = true;
          self.accessLoading = false;
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['slackChannels.channel_unavailable'], duration: 6});
          self.checkAccessId = '';
          self.showSelector = false;
          self.accessLoading = false;
        })
      };

      self.initialize = function() {
        self.init = true;
        var include_list = $scope.list ? $scope.list.join(',') : '';

        SlackMessage.getChannels({include_list: include_list}).$promise
        .then(function(results) {
          self.channels = results && results.channels || [];
          self.channels.forEach(function(item) {
            item.text = item.name;
            item.type = item.id;
            self.directory[item.id] = item.name;
          });
          self.setActiveChannels();
        }).catch(function(error) {
          console.log('error in slack channels: ', error)
          if (error && error.data && error.data.error && error.data.error === 'missing_scope') {
            Application.messaging.addMessage({type: 'error', duration: 7, text: 'Your Slack integration is out of date. Please reinstall through your integrations section in Slack to use this functionality.'});
          }
        })
      };

      $translate([
        "slackChannels.previously_added",
        "slackChannels.channel_added",
        "slackChannels.channel_unavailable"
      ]).then(function(translations){
        self.translations = translations;
      });

      if ($scope.list) {
        self.initialize();
      }

    }],
    controllerAs: 'slackChannels'
  };
}]);